export const ItemType = {
  CAR: 'Car',
  WATCH: 'Watch',
  COMIC: 'Comic',
  ANTIQUE: 'Antique',
  ART: 'Art',
  BOOK: 'Book',
  CAMERA: 'Camera',
  FIREARM: 'Firearm',
  HANDBAG: 'Handbag',
  JEWELRY: 'Jewelry',
  TOY: 'Toy',
  STAMP: 'Stamp',
  COIN: 'Coin',
  SPORTS_CARD: 'Sports Card',
  VINYL_RECORD: 'Vinyl Record',
  MUSICAL_MEM: 'Musical Memorabilia',
  SPORTS_MEM: 'Sports Memorabilia',
  HISTORIC_MEM: 'Historical Memorabilia',
  MOVIE_MEM: 'Movie Memorabilia',
  MUSICAL_INST: 'Musical Instrument',
  WINE: 'Wine',
  OTHER: 'Other',
};

export const ItemTypePlural = {
  CAR: 'Cars',
  WATCH: 'Watches',
  COMIC: 'Comics',
  ANTIQUE: 'Antiques',
  ART: 'Art',
  BOOK: 'Books',
  CAMERA: 'Cameras',
  FIREARM: 'Firearms',
  HANDBAG: 'Handbags',
  JEWELRY: 'Jewelry',
  TOY: 'Toys',
  STAMP: 'Stamps',
  COIN: 'Coins',
  SPORTS_CARD: 'Sports Cards',
  VINYL_RECORD: 'Vinyl Records',
  MUSICAL_MEM: 'Musical Memorabilia',
  SPORTS_MEM: 'Sports Memorabilia',
  HISTORIC_MEM: 'Historical Memorabilia',
  MOVIE_MEM: 'Movie Memorabilia',
  MUSICAL_INST: 'Musical Instruments',
  WINE: 'Wine',
  OTHER: 'Others',
};

export function convertType(type) {
  if (ItemType[type]) {
    return type;
  }

  return 'OTHER';
}

export function getItemCategory(item, asObject) {
  // just return category if not 'OTHER'
  if (item.category !== 'OTHER') {
    if (asObject) {
      return item.category;
    }

    return ItemType[item.category];
  }

  // return the other 'type' if category is 'OTHER'
  return item.specificData.o_type;
}

export function getItemCategoryPlural(item, asObject) {
  // just return category if not 'OTHER'
  if (item.category !== 'OTHER') {
    if (asObject) {
      return item.category;
    }

    return ItemTypePlural[item.category];
  }

  // return the other 'type' if category is 'OTHER'
  return item.specificData.o_type;
}

export function getItemType(item, realType) {
  // if the type exist in ItemType then return the relevant object
  if (ItemType[item]) {
    return ItemType[item];
  }

  // if we get the type is 'OTHER' if we want the real type we return the 'OTHER' Object
  if (realType) {
    return ItemType.OTHER;
  }

  // otherwise we want the display name which will be what we passed in
  return item;
}

export function getItemTypePlural(item, realType) {
  // if the type exist in ItemType then return the relevant object
  if (ItemTypePlural[item]) {
    return ItemTypePlural[item];
  }

  // if we get the type is 'OTHER' if we want the real type we return the 'OTHER' Object
  if (realType) {
    return ItemTypePlural.OTHER;
  }

  // otherwise we want the display name which will be what we passed in
  return item;
}
export const ItemOptions = [

  {
    label: 'Antiques',
    value: 'ANTIQUE',
    id: 'antique',
  },

  {
    label: 'Art',
    value: 'ART',
    id: 'art',
  },

  {
    label: 'Books',
    value: 'BOOK',
    id: 'book',
  },

  {
    label: 'Cameras',
    value: 'CAMERA',
    id: 'camera',
  },

  {
    label: 'Cars',
    value: 'CAR',
    id: 'car',
  },

  {
    label: 'Coins',
    value: 'COIN',
    id: 'coin',
  },

  {
    label: 'Comics',
    value: 'COMIC',
    id: 'comic',
  },

  {
    label: 'Firearms',
    value: 'FIREARM',
    id: 'firearm',
  },

  {
    label: 'Handbags',
    value: 'HANDBAG',
    id: 'handbag',
  },

  {
    label: 'Historical Memorabilia',
    value: 'HISTORIC_MEM',
    id: 'historicalMemorabilia',
  },

  {
    label: 'Jewelry',
    value: 'JEWELRY',
    id: 'jewelry',
  },

  {
    label: 'Movie Memorabilia',
    value: 'MOVIE_MEM',
    id: 'movieMemorabilia',
  },

  {
    label: 'Musical Instrument',
    value: 'MUSICAL_INST',
    id: 'musicalInstrument',
  },

  {
    label: 'Musical Memorabilia',
    value: 'MUSICAL_MEM',
    id: 'musicalMemorabilia',
  },

  {
    label: 'Sports Cards',
    value: 'SPORTS_CARD',
    id: 'sportcard',
  },

  {
    label: 'Sports Memorabilia',
    value: 'SPORTS_MEM',
    id: 'sportsMemorabilia',
  },

  {
    label: 'Stamps',
    value: 'STAMP',
    id: 'stamp',
  },

  {
    label: 'Toys',
    value: 'TOY',
    id: 'toy',
  },

  {
    label: 'Vinyl Records',
    value: 'VINYL_RECORD',
    id: 'vinylrecord',
  },

  {
    label: 'Watches',
    value: 'WATCH',
    id: 'watch',
  },

  {
    label: 'Wine',
    value: 'WINE',
    id: 'wine',
  },

  {
    label: 'Other',
    value: 'OTHER',
    id: 'other',
  },

];

export const Rarity = {
  Common: 'Common',
  'Less Common': 'Less Common',
  Rare: 'Rare',
  'Extremely Rare': 'Extremely Rare',
};

export const OwnershipStatus = {
  'In Collection': 'In Collection',
  'Under Restoration': 'Under Restoration',
  'On Consignment': 'On Consignment',
  'On Loan': 'On Loan',
  Gifted: 'Gifted',
  'Lost/Stolen/Destroyed': 'Lost/Stolen/Destroyed',
  Sold: 'Sold',
};

export const UnownedOwnershipStatuses = [
  OwnershipStatus['Lost/Stolen/Destroyed'],
  OwnershipStatus.Sold,
];

export const StampPurchaseCondition = {
  Mint: 'Mint',
  Used: 'Used',
  'Unused (Small Flaw)': 'Unused (Small Flaw)',
  'Used (Small Flaw)': 'Used (Small Flaw)',
};

export const StampFormat = {
  'Single Stamp': 'Single Stamp',
  Cover: 'Cover',
  'First Day Cover': 'First Day Cover',
  'Strip of 3': 'Strip of 3',
  'Strip of 4': 'Strip of 4',
  'Strip of 5': 'Strip of 5',
  'Coil Pair': 'Coil Pair',
  'Souvenir Page': 'Souvenir Page',
  'Plate Block': 'Plate Block',
  'Block of Four': 'Block of Four',
  Sheet: 'Sheet',
  'Album Page': 'Album Page',
  Booklet: 'Booklet',
  'Lot of Stamps': 'Lot of Stamps',
};

export const StampHinged = {
  'Heavily Hinged': 'Heavily Hinged',
  Hinged: 'Hinged',
  'Hinged Lightly': 'Hinged Lightly',
  'HM - Hinge Mark': 'HM - Hinge Mark',
  'HR - Hinge Remnant': 'HR - Hinge Remnant',
  'Never Hinged': 'Never Hinged',
  'Very Lightly Hinged': 'Very Lightly Hinged',
};

export const StampCentering = {
  Poor: 'Poor',
  Average: 'Average',
  Fine: 'Fine',
  'Fine/Very Fine': 'Fine/Very Fine',
  'Very Fine': 'Very Fine',
  'Extra Fine': 'Extra Fine',
  Superb: 'Superb',
};

export const StampCancel = {
  'Fancy Cancel': 'Fancy Cancel',
  'Light Cancel': 'Light Cancel',
  'Average Cancel': 'Average Cancel',
  'Heavy Cancel': 'Heavy Cancel',
  'Pre-Cancel': 'Pre-Cancel',
};

export const StampGumCondition = {
  'OG - Original Gum': 'OG - Original Gum',
  'NG - No Gum': 'NG - No Gum',
  'No Gum As Issued': 'No Gum As Issued',
  'RG - Re-Gummed': 'RG - Re-Gummed',
  'PG - Partial Gum': 'PG - Partial Gum',
  'Self-Adhesive': 'Self-Adhesive',
  'Self-Adhesive (Original Backing)': 'Self-Adhesive (Original Backing)',
  'DOG - Damages Original Gum': 'DOG - Damages Original Gum',
};

export const StampGrade = {
  'Mint-VG': 'Mint-VG',
  'Mint-F': 'Mint-F',
  'Mint-VF': 'Mint-VF',
  'Mint-XF': 'Mint-XF',
  'Used-VG': 'Used-VG',
  'Used-F': 'Used-F',
  FDC: 'FDC',
  'Used-VF': 'Used-VF',
  'Used-XF': 'Used-XF',
};

export const StampType = {
  Definitive: 'Definitive',
  Commemoratives: 'Commemoratives',
  Special: 'Special',
};

export const StampCondition = {
  Mint: 'Mint',
  Used: 'Used',
  'Unused (Small Flaw)': 'Unused (Small Flaw)',
  'Used (Small Flaw)': 'Used (Small Flaw)',
};

export const WatchCondition = {
  New: 'New',
  Mint: 'Mint',
  Great: 'Great',
  Fair: 'Fair',
  Salvage: 'Salvage',
  Vintage: 'Vintage',
};

export const CarCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const AntiqueCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const AntiquePurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const ArtCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const CoinGrade = {
  'MS/PF 70': 'MS/PF 70',
  'MS/PF 69': 'MS/PF 69',
  'MS/PF 68': 'MS/PF 68',
  'MS/PF 67': 'MS/PF 67',
  'MS/PF 66': 'MS/PF 66',
  'MS/PF 65': 'MS/PF 65',
  'MS/PF 64': 'MS/PF 64',
  'MS/PF 63': 'MS/PF 63',
  'MS/PF 62': 'MS/PF 62',
  'MS/PF 61': 'MS/PF 61',
  'MS/PF 60': 'MS/PF 60',
  'AU 58': 'AU 58',
  'AU 55': 'AU 55',
  'AU 53': 'AU 53',
  'AU 50': 'AU 50',
  'XF 45': 'XF 45',
  'XF 40': 'XF 40',
  'VF 35': 'VF 35',
  'VF 30': 'VF 30',
  'VF 25': 'VF 25',
  'VF 20': 'VF 20',
  'F 15': 'F 15',
  'F 12': 'F 12',
  'VG 10': 'VG 10',
  'VG 8': 'VG 8',
  'G 6': 'G 6',
  'G 4': 'G 4',
  'AG 3': 'AG 3',
  'FR 2': 'FR 2',
  'PO 1': 'PO 1',
  'Not Graded': 'Not Graded',
};

export const CoinPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const CoinCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const BookFormat = {
  Hardcover: 'Hardcover',
  Paperback: 'PaperBack',
  Softcover: 'Softcover',
};

export const BookPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const BookCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const ArtPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const HandbagCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const HandbagPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const JewelryCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const JewelryPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const ToyCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const ToyPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const SportsCardCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const SportsCardPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const VinylRecordCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const VinylRecordPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const CameraCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const CameraPurchaseCondition = {
  New: 'New',
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const FireArmCondition = {
  'Factory New': 'Factory New',
  New: 'New',
  Perfect: 'Perfect',
  Excellent: 'Excellent',
  Fine: 'Fine',
  'Very Good': 'Very Good',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
};

export const FireArmPurchaseCondition = {
  'Factory New': 'Factory New',
  Perfect: 'Perfect',
  New: 'New',
  Excellent: 'Excellent',
  Fine: 'Fine',
  'Very Good': 'Very Good',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
};

export const FireArmAction = {
  'Blow - back operation': 'Blow - back operation',
  'Blow - forward operation': 'Blow - forward operation',
  'Bolt action': 'Bolt action',
  'Break action': 'Break action',
  Caplock: 'Caplock',
  'Dropping block': 'Dropping block',
  'Falling block': 'Falling block',
  Flintlock: 'Flintlock',
  'Gas operartion': 'Gas operartion',
  'Hinged block': 'Hinged block',
  'Lever - action': 'Lever - action',
  Matchlock: 'Matchlock',
  'Pump - action': 'Pump - action',
  'Recoil operation': 'Recoil operation',
  Revolver: 'Revolver',
  'Rolling block': 'Rolling block',
  'Tilting block': 'Tilting block',
  Wheellock: 'Wheellock',
};

export const SportsCardType = {
  NBA: 'NBA',
  NFL: 'NFL',
  NHL: 'NHL',
  MLB: 'MLB',
};

export const JewelryType = {
  Anklets: 'Anklets',
  Armlets: 'Armlets',
  Bracelets: 'Bracelets',
  Brooches: 'Brooches',
  Earings: 'Earings',
  Fobs: 'Fobs',
  'Hair Ornaments': 'Hair Ornaments',
  Headgear: 'Headgear',
  Labrets: 'Labrets',
  Necklaces: 'Necklaces',
  'Nose Ornaments': 'Nose Ornaments',
  Pectorals: 'Pectorals',
  Pendants: 'Pendants',
  Pins: 'Pins',
  Pompons: 'Pompons',
  Rings: 'Rings',
};

export const ToyType = {
  'Action Figure': 'Action Figure',
  Diecast: 'Diecast',
  Doll: 'Doll',
  Figurine: 'Figurine',
  Model: 'Model',
};

export const ComicCondition = {
  'Near Mint': 'Near Mint',
  'Very Fine': 'Very Fine',
  Fine: 'Fine',
  'Very Good': 'Very Good',
  Good: 'Good',
  Fair: 'Fair',
  'Very poor': 'Very Poor',
};

export const SportsMemCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Game Worn': 'Game Worn',
};

export const SportsMemPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Game Worn': 'Game Worn',
};

export const MusicMemCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const MusicMemPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const MusicalInstrumentCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const MusicalInstrumentPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const WineCondition = {
  New: 'New',
  Vintage: 'Vintage',
};

export const WinePurchaseCondition = {
  New: 'New',
  Vintage: 'Vintage',
};


export const HistoricalMemCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const HistoricalMemPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};


export const MovieMemCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const MovieMemPurchaseCondition = {
  Excellent: 'Excellent',
  Good: 'Good',
  Fair: 'Fair',
  Poor: 'Poor',
  'Very Poor': 'Very Poor',
};

export const CarDrive = {
  'Left Hand Drive': 'Left Hand Drive',
  'Right Hand Drive': 'Right Hand Drive',
};

export const YesNoState = {
  Yes: 'Yes',
  No: 'No',
};

export const BookGenre = {
  Action: 'Action',
  Adventure: 'Adventure',
  Autobiography: 'Autobiography',
  Biography: 'Biography',
  Comedy: 'Comedy',
  Crime: 'Crime',
  Fantasy: 'Fantasy',
  Fiction: 'Fiction',
  Horror: 'Horror',
  Literature: 'Literature',
  'Non - Fiction': 'Non - Fiction',
  Poetry: 'Poetry',
  Reference: 'Reference',
  Religious: 'Religious',
  Romantic: 'Romantic',
  'Sci - Fi': 'Sci - Fi',
  'Science Fiction': 'Science Fiction',
  Scientific: 'Scientific',
  Thriller: 'Thriller',
  Travel: 'Travel',
};

export const CarState = {
  Original: 'Original',
  Modified: 'Modified',
  Restored: 'Restored',
};

export const AttachmentType = {
  IMAGE: 'IMAGE',
  ITEM: 'ITEM',
  PURCHASE: 'PURCHASE',
  APPRAISAL: 'APPRAISAL',
  GRADING: 'GRADING',
  INSURANCE: 'INSURANCE',
  CONSERVATION: 'CONSERVATION',
};

export const AttachmentTypeFriendlyName = {
  IMAGE: 'Image',
  ITEM: 'Item',
  PURCHASE: 'Purchase',
  APPRAISAL: 'Appraisal',
  GRADING: 'Grading',
  INSURANCE: 'Insurance',
};

export const ContactTypes = {
  Collector: 'Collector',
  Dealer: 'Dealer',
  Organization: 'Organization',
  Other: 'Other',
};

export const TransactionType = {
  ACQUIRED: 'AQUIRED',
  DISPOSED: 'DISPOSED',
};

export const STOCK_ITEM_NULL_LABEL = 'No Value';

export const CollectionFilterTypes = {
  ALL: 'ALL',
  IN_COLL: 'IN_COLL',
  NOT_IN_COLL: 'NOT_IN_COLL',
};



// WEBPACK FOOTER //
// ./src/config/constants.js